import { EconomyConfigPage } from "../../features/economy";

export function AdminEconomyPage() {
  return <EconomyConfigPage />;
}
